<app-challenges-base-card
  [challenge]="challenge"
  [createdByLabel]="'challenges.createdByYou'"
  [icon]="'challenge_daily'"
  [iconSize]="'2x'"
  [progressLabel]="'general.pluralMinute'"
  [showEditMenu]="challenge !== undefined"
  (deleteChallenge)="handleDelete()"
  (updateChallenge)="handleUpdate()"
>
  <div class="create-container" slot="empty-challenge">
    <span>
      {{ 'challenges.dailyGoalText' | translate }}
    </span>

    <opac-button (click)="handleCreateButtonClick()">
      <opac-icon icon="alarm" slot="start"></opac-icon>
      {{ 'challenges.dailyGoalTitle' | translate }}
    </opac-button>
  </div>

  <app-challenges-daily-content *ngIf="challenge" [dailyContents]="challenge.contents" [dailyTarget]="challenge.target"></app-challenges-daily-content>
</app-challenges-base-card>
